import React from 'react';
import { Tabs } from 'antd';
import styles from './index.module.scss'


const TabCom = (props) => {
    const onChange = key => {
        props.getActiveIndex(key)
    }
    return <Tabs className={styles.tabCom} items={props.items} onChange={onChange} />
}

export default TabCom;